import { colors } from '@lmc/common/constants'

export const glyphColors = {
  danger: '#d64242',
  inherit: 'inherit',
  inverted: 'white',
  primary: colors.primary,
  success: colors.successgreen,
  warning: '#FA3',
}

export default glyphColors
